import { z } from "zod";

// TODO review these nullish() (these were nullable)
export const locationSavedSchema = z.object({
	productionGroup: z.string().nullish(),
	machineGroup: z.string().nullish(),
	machine: z.string().nullish(),
	packStation: z.string().nullish(),
	pickZone: z.string().nullish(),
});
